import { CardSize, CardType } from '../../api/models/Shared.types';
import { Backend } from '../../api/Backend';

export const Recipes = {
  DetailPosterRecipe: 'card-landscape-large-4',
  LandscapeCard: {
    Small: 'card-landscape-small-2',
    Medium: 'card-landscape-medium-2',
    Normal: 'card-landscape-normal-2',
    Large: 'card-landscape-large-2',
    ExtraLarge: 'card-landscape-extra-large-2',
  },
  PortraitCard: {
    Small: 'card-portrait-small-2',
    Medium: 'card-portrait-medium-2',
    Normal: 'card-portrait-normal-2',
    Large: 'card-portrait-large-2',
    ExtraLarge: 'card-portrait-extra-large-2',
  },
  SmallChannelLogo: 'channel-epg-card-1',
  MediumChannelLogo: 'channel-epg-card-2',
  Channel: 'channel-1',
  Banner: {
    Small: 'banner-7x1-3',
    Medium: 'banner-7x2-3',
    Large: 'banner-7x3-3',
  },
  Page: {
    Background: 'custom-background-2',
  },
  Profile: {
    Small: 'avatar-1',
    Medium: 'avatar-2',
    Normal: 'avatar-3',
    Large: 'avatar-4',
  },
  AutoplayFullscreen: 'autoplay-background-2',
  Reminder: 'epg-card-2',
};

/**
 * create an url with an image recipe attached
 * @param {string} url
 * @param {string} recipe
 * @returns {string}
 */
export function urlWithRecipe(url: string, recipe: string): string | undefined {
  if (!url) return undefined;
  return `${url}?form=${recipe}`;
}

/**
 * Retrieve the full image url
 * @param {Backend} backend
 * @param {string | undefined} urlPart
 * @param {string | undefined} recipe
 * @returns {string|null}
 */
export function fullUrlWithRecipe(
  backend: Backend,
  urlPart: string | undefined,
  recipe: string | undefined
): string | null {
  if (urlPart && recipe) {
    const sep = urlPart.startsWith('/') ? '' : '/';
    const prefix = urlPart.startsWith('http') ? '' : `${backend.imageURL}${sep}`;
    return `${prefix}${urlPart}?form=${recipe}`;
  }
  return null;
}

/**
 * Retrieve the image recipe we should use
 * @param {string} cardType
 * @param {string} cardSize
 * @returns {string}
 */
export function imageRecipeForCard(cardType: string, cardSize: string): string {
  // console.log('imageRecipeForCard', cardType, cardSize);
  const recipes = cardType === CardType.Landscape ? Recipes.LandscapeCard : Recipes.PortraitCard;
  switch (cardSize) {
    case CardSize.Small:
      return recipes.Small;
    case CardSize.Medium:
      return recipes.Medium;
    case CardSize.Large:
      return recipes.Large;
    case CardSize.ExtraLarge:
      return recipes.ExtraLarge;
  }
  return recipes.Normal;
}
